import * as etplayer from "./etplayer"
import * as modAjax from "./modAjax";
import * as modList from "./modList";
import * as modLocale from "./modLocale";
import * as modPlayer from "./modPlayer";

export class ArchiveData {
    folders?: Entry;
    playlists?: Entry;
    userPlaylists?: Entry;
    radio?: Entry;
}

class JinglesData {
    jingles?: Entry;
}

export type ArchiveResult = etplayer.Result<ArchiveData>;
type JinglesResult = etplayer.Result<JinglesData>;

export class Entry {
    id?: number;
    name?: string;
    type?: string;
    mutable?: boolean;
    new?: boolean;
    children?: Entry[];

    title?: string;
}

class SongInfo {
    id?: number;
    title?: string;
    artist?: string;
    album?: string;

    duration?: number; // in seconds
    pls?: {[id: number]: string}

    previewUrl?: string
}

export function reloadWidget() {
    return getArchive().then((data) => {
        gotArchive(data);
    });
}

class TreeItem {
    entity:Entry

    li: JQuery<HTMLLIElement> = $("<li>");
    titleDiv = $("<div>").addClass('title clickable') as JQuery<HTMLDivElement>;
    submenuUl?: JQuery<HTMLUListElement> = null;

    parent?: TreeItem = null;
    children: TreeItem[] = [];

    isExpanded: boolean = false;

    constructor(parent: TreeItem|null, entity:Entry) {
        this.parent = parent;
        this.entity = entity;

        if (entity.mutable === true) {
            etplayer.setDropHandler(this.titleDiv, dropItem);
        }

        if (entity.type == "folder") this.titleDiv.addClass('folder');
        if (entity.type == "stream") this.titleDiv.addClass('stream');
        this.titleDiv.data('treeItem', this);
    }

    getEntityId() { return etplayer.entityId(this.entity.type, this.entity.id); }
    isDeletable() { return this.titleDiv.hasClass('deletable'); }

    // expand/collapse (or toggle) a TreeItem
    expand(newValue?:boolean) {
        if (newValue == undefined) {
            newValue = !this.isExpanded;
        }
        this.isExpanded = newValue;
        if (!newValue && this.entity.type == 'folder') this.li.addClass("collapsed");
        else this.li.removeClass("collapsed");

        if (newValue && this.parent != null) {
            this.parent.expand(newValue);
        }
    }

    getPath() {
        var rc = []
        var item:TreeItem = this;
        while (item != null) {
            rc.unshift(item.titleDiv.text());
            item = item.parent;
        }
        return rc;
    }

    markNew() {
        if (this.parent == null) return; // root TreeItems won't be marked as new
        this.titleDiv.addClass('new');
        this.parent.markNew();
    }
};


class ArchiveTree {
    treeItems: {[entityId:string]: TreeItem} = {};
    archiveUl: JQuery<HTMLElement>;
    rootItems: TreeItem[] = [];

    selectedItem?: TreeItem = null;

    constructor(archiveUl: JQuery<HTMLElement>) {
        this.archiveUl = archiveUl;
        archiveUl.data('archiveTree', this);
    }

    addFolder(obj: Entry, expanded: boolean, title?: string, classes?: string): TreeItem {
        var rc = this._addFolderRec(null, obj, expanded, title, classes);
        this.rootItems.push(rc);
        this.archiveUl.append(rc.li);
        return rc;
    }
    _addFolderRec(parent:TreeItem|null, obj: Entry, expanded: boolean, title?: string, classes?: string): TreeItem {
        var rc = new TreeItem(parent, obj);
        var entityId = etplayer.entityId(obj.type, obj.id)
        var text: string = obj.name ? obj.name : 'ERROR';
        if (title != undefined) text = title;
        else if (text === undefined) text = obj.title ? obj.title : 'ERROR';

        rc.titleDiv.text(text);
        rc.titleDiv.data('type', obj.type || null)
        if (obj.id !== undefined) rc.titleDiv.data('id', obj.id);

        // make items draggable
        rc.titleDiv.attr("draggable", "true").on('dragstart', dragItem);

        if (classes !== undefined) rc.titleDiv.addClass(classes);

        rc.li.append(rc.titleDiv);
        parent?.submenuUl.append(rc.li);

        if (obj.children && obj.children.length > 0) {
            rc.submenuUl = $("<ul>");
            //$ul.attr('id', $titleDiv.attr('id')+"_submenu");
            rc.li.append(rc.submenuUl);
            for (var i in obj.children) {
                var childObj = obj.children[i];
                var childItem = this._addFolderRec(rc, childObj, false, undefined, classes);
                rc.children.push(childItem);
            }
        }
        rc.titleDiv.on('click', itemClicked);
        rc.expand(expanded);

        // mark new playlists (and their parent directories)
        if (obj.new === true) {
            rc.markNew();
        }

        if (this.treeItems[entityId]) {
            console.error("duplicate entityId in ArchiveTree: ", entityId);
        }
        this.treeItems[entityId] = rc;
        return rc;
    }

    getTreeItem(entityId:string): TreeItem {
        return this.treeItems[entityId];
    }

    static get(archiveUl: JQuery<HTMLUListElement>): ArchiveTree {
        return archiveUl.data('archiveTree') as ArchiveTree;
    }

    listExpandedItems(): {[entityId: string]:TreeItem} {
        var rc:{[entityId:string]:TreeItem} = {}
        for (var entityId in this.treeItems) {
            var treeItem = this.treeItems[entityId];
            if (treeItem.isExpanded) rc[entityId] = treeItem;
        }
        return rc;
    }

    selectItem(treeItem: TreeItem, scroll?: boolean) {
        this.selectedItem = treeItem;
        let $archive = $('#archive');

        modList.selectionChanged($archive, treeItem.titleDiv);
        modList.songlist.load(treeItem.entity.type, treeItem.entity.id, treeItem.isDeletable());
        treeItem.expand(); // toggle

        if (scroll === true) {
            treeItem.expand(true); // expand (recursively))

            // scroll to item
            let offset = treeItem.titleDiv.offset(), scrollTop = $archive.scrollTop();
            if (offset==undefined || scrollTop == undefined) throw("modArchive.selectItem: missing element position")
            $archive.animate({
                scrollTop: offset.top - $archive.offset().top + scrollTop,
            }, 300);
        }

        // enable/disable dropping songs on the songlist
        if (treeItem.entity.mutable === true) $('#songlist').removeData('nodrop');
        else $('#songlist').data('nodrop', true);
    }
}


export function deleteSelectedPlaylist() {
    let archive = ArchiveTree.get($('#archive'));
    let selectedItem = archive.selectedItem;
    let action: string|undefined;
    let postData: object;
    let $dlg: JQuery<HTMLDivElement>|undefined;

    if (selectedItem == null) return;
    let selectedEntity = selectedItem.entity;

    if (selectedEntity.type == 'playlist') {
        action = 'delete';
        postData = {'plId': selectedEntity.id};
        $dlg = etplayer.showDialog('#deletePlDialog');
    }
    else if (selectedEntity.type == 'folder') {
        action = 'rmdir';
        postData = {'folderId': selectedEntity.id};
        $dlg = etplayer.showDialog('#deleteFolderDialog');
    }
    if (!action || !$dlg) throw "can't delete "+selectedEntity.type;

    var $pathUl = $('.path', $dlg).empty();
    var selectedPath = selectedItem.getPath();
    for (var i = 1; i < selectedPath.length; i++) {
        $pathUl.append($('<li>').text(selectedPath[i]));
    }

    $('.btnDelete', $dlg).off('click').on('click', () => {
        $('#loadingAnim').show();
        _deleteThing(action, postData).then((data) => {
            etplayer.hideDialog('#deletePlDialog');
            $('#loadingAnim').hide();
        });
    });
}

export function deleteUserFolder(folderId:number) {
    return _deleteThing('rmdir', {'folderId': folderId});
}
export function deleteUserPlaylist(plId:number) {
    return _deleteThing('delete', {'plId': plId});
}

function _deleteThing(action:string, postData:object) {
    let rc = modAjax.post("archive/playlist/"+action+"?radio=true", postData);
    rc.then((data) => {
        gotArchive(data);
        $('#loadingAnim').hide();
    });
    return rc;
}

function dragItem(ev: JQuery.DragStartEvent) {
    var dataTransfer = ev.originalEvent?.dataTransfer;
    if (!dataTransfer) throw("archive.dragItem: missing dataTransfer");

    var $elem = $(ev.target);
    let data: etplayer.DraggedList = [{type: $elem.data('type'), id: $elem.data('id')}];
    dataTransfer.setData(etplayer.ERT_MIMETYPE, JSON.stringify(data));
}

function dropItem(ev: JQuery.DropEvent) {
    var dataTransfer = ev.originalEvent?.dataTransfer;
    if (!dataTransfer) throw("archive.dropItem: missing dataTransfer");

    var $elem = $(ev.target);
    var plId = $elem.data('id');
    var data: etplayer.DraggedList = JSON.parse(dataTransfer.getData(etplayer.ERT_MIMETYPE));
    if ($elem.data('type') != 'playlist') throw "can't drop on non-playlists!";
    console.log("drop:", data);
    modAjax.request("/archive/playlist/add?plId="+plId, JSON.stringify(data), {
        method: 'POST',
        contentType: "application/json",
    }).then((_data) => {
        // we're dropping into an invisible playlist here -> don't reload playlistWidget
        //modList.playlist.loadData(data);
    });
}

export function fetchSongInfo(id: number): JQuery.Deferred<SongInfo> {
    let rc = $.Deferred();
    modAjax.request('/archive/song/'+id).then((data) => {
        rc.resolve(data.result);
    }).failOtherPromise(rc);
    return rc;
}

function itemClicked(ev: JQuery.ClickEvent) {
    var treeItem = $(ev.target).data('treeItem') as TreeItem;
    if (treeItem == null) return;
    ArchiveTree.get($("#archive")).selectItem(treeItem);
    ev.stopPropagation();
}

export function getArchive(reload=false): JQueryDeferred<ArchiveResult> {
    var rc = $.Deferred();
    if (reload || getArchive._archive === null) {
        modAjax.request('/archive?radio=true').then((data: ArchiveResult) => {
            rc.resolve(data);
        }).failOtherPromise(rc);
    }
    else rc.resolve(getArchive._archive);
    return rc;
}
getArchive._archive = null as ArchiveResult|null;

export function getJingles(reload=false): JQueryDeferred<JinglesResult> {
    var rc = $.Deferred();
    if (reload || getJingles._jingles === null) {
        modAjax.request('/archive/jingles').then((data: JinglesResult) => {
            rc.resolve(data);
        }).failOtherPromise(rc);
    }
    else rc.resolve(getJingles._jingles);
    return rc;
}
getJingles._jingles = null as JinglesResult|null;

export function gotArchive(data: ArchiveResult) {
    if (data.result == undefined) return;

    // save expanded+selected folders
    var archive = ArchiveTree.get($("#archive"));
    var expandedItems = archive?.listExpandedItems() || {};
    var selectedId = archive?.selectedItem?.getEntityId();

    // reload data
    var archive = new ArchiveTree($('#archive').empty());

    if (data.result.playlists !== undefined) {
        archive.addFolder(data.result.playlists, true, "Eartunes").titleDiv.attr('data-tr', 'archive.playlists');
    }
    if (data.result.userPlaylists !== undefined) {
        archive.addFolder(data.result.userPlaylists, true, "My Eartunes", 'deletable').titleDiv.attr('data-tr', 'archive.userPlaylists').removeClass('deletable');
    }
    if (data.result.radio !== undefined) {
        archive.addFolder(data.result.radio, true, "Eartunes Radio").titleDiv.attr('data-tr', 'archive.radio');
    }
    if (data.result.folders !== undefined) {
        archive.addFolder(data.result.folders, false, "Music Archive").titleDiv.attr('data-tr', 'archive.archive').parent().attr('id', 'archiveRoot');
    }

    etplayer.getAppState().then((appState) => {
        if (!appState.capabilities.showMusicArchive) {
            $('#archiveRoot').css({'display': 'none'});
        }
    });

    modLocale.set(undefined, archive.archiveUl);

    // re-expand folders
    for (var entityId in archive.treeItems) {
        if (!expandedItems[entityId]) continue;
        var treeItem = archive.treeItems[entityId];
        treeItem.expand(true);
    }
    if (selectedId != null) {
        var selectedItem = archive.getTreeItem(selectedId);
        if (TreeItem != null) archive.selectItem(selectedItem);
    }
}

export function loadCurrent(append: boolean) {
    var cmd="load";
    if (append) cmd="append";

    $('#archive .selected').each(function() {
        var data={type: $(this).data('type'), id: $(this).data('id')};
        modList.playlist.showLoadingIndicator();
        modAjax.post("/player/"+modPlayer.getId()+"/playlist/"+cmd, data).then((data) => {
            modList.playlist.loadData(data);
        });
        cmd = 'append'; // if more than one were selected, append all but the first
    });
    $('body').removeClass('showOverlay');
}

// scrolls down by 'direction * height'
export function scrollPage(direction: number) {
    let $archive = $('#archive');
    let scrollTop = $archive.scrollTop();
    let height = $archive.height();
    if (scrollTop == undefined || height == undefined) throw "modArchive.scrollPage(): undefined height and/or scrollTop";

    let tgtPos = scrollTop + height * direction; // scroll a whole page
    scrollTo(tgtPos);
}

export function scrollTo(pos: number) {
    let $archive = $('#archive');
    let scrollTop = $archive.scrollTop();
    let height = $archive.height();
    if (scrollTop == undefined || height == undefined) throw "modArchive.scrollTo(): undefined height and/or scrollTop";
    if (Math.abs(scrollTop-pos) <= height+100) {
        // animate scroll if it's not too far
        $archive.stop().animate({scrollTop:pos}, 250);
    }
    else $archive.stop().scrollTop(pos);
}

function selectEntity(entityId: string, scroll?:boolean) {
    var archiveTree = ArchiveTree.get($('#archive'));
    var treeItem = archiveTree.getTreeItem(entityId);
    if (treeItem == null) return;

    console.log("selecting entity: ", treeItem.getPath());
    archiveTree.selectItem(treeItem, scroll);
}

// show playlists for a song
export function showPlaylists(pls: { [id: number]: string; }) {
    var $ul = $('#songPlaylists ul');
    $ul.empty();
    for (var plId in pls) {
        var name = pls[plId];
//		console.log('pl: ', plId, " - ", name);
        var li = document.createElement('li');
        var div = document.createElement('div');
        div.dataset['type'] = 'playlist';
        div.dataset['id'] = plId;
        div.className = 'title clickable';
        $(div).text(name).on('click', function(_ev) {
            console.log('pl clicked: ', this.dataset);
            var type = this.dataset['type'], id=this.dataset['id'];
            if (type==undefined || id==undefined) throw "showPlaylists: missing id/type"
            selectEntity(etplayer.entityId(type, id), true);
        });
        li.appendChild(div);
        $ul.append(li);
    }

    $('#songPlaylists').removeClass('hidden');
}
